import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftSelect from 'components/SoftSelect';

const TrafficStatesSelector = ({ baseOptions = null, selectedTrafficStates, setSelectedTrafficStates }) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Si se pasan opciones base, se usan y se evita la petición a la API
    if (baseOptions !== null) {
      setOptions(baseOptions);
      setIsLoading(false);
      return;
    }

    // Configuramos el cancel token para poder cancelar la petición en caso de desmontaje
    const source = axios.CancelToken.source();

    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/maintenance/traffic-states/`, {
      cancelToken: source.token,
    })
      .then(response => {
        const data = response.data;
        console.log(data)
        // Mapeamos la data para ajustarla al formato requerido por SoftSelect
        const mappedOptions = data.map(option => ({
          label: option.nombre_estado_trafico,
          value: option.id_estado_trafico,
          ...option,
        }));
        setOptions(mappedOptions);
        setIsLoading(false);
      })
      .catch(err => {
        if (axios.isCancel(err)) {
          console.log('Request canceled:', err.message);
        } else {
          setError(err.message);
          setIsLoading(false);
        }
      });

    // Cleanup: cancelar la petición si el componente se desmonta
    return () => {
      source.cancel('Operation canceled by the user.');
    };
  }, [baseOptions]);

  return (
    <SoftBox>
      <SoftTypography 
        variant="caption"
        fontWeight="bold"
        color="text"
      >
        Estado
      </SoftTypography>
      <SoftSelect
        options={options}
        value={options.find(option => option.value === selectedTrafficStates)}
        onChange={setSelectedTrafficStates}
        isLoading={isLoading}
        placeholder="Seleccione un estado"
        error={error}
      />
    </SoftBox>
  );
};

TrafficStatesSelector.propTypes = {
  baseOptions: PropTypes.array,
  selectedTrafficStates: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
    PropTypes.string,
  ]),
  setSelectedTrafficStates: PropTypes.func,
};

export default TrafficStatesSelector;
